import CurrentlyReadingCard from "components/Bookcards/CurrentlyReadingCard/CurrentlyReadingCard";
import { LetterbookLibraryType } from "features/Letterbooks/types";

export default function LetterbookCurrentlyReadingRow({
  letterbook,
}: {
  letterbook: LetterbookLibraryType;
}) {
  const { book, data } = letterbook;
  const { ownerUserBook } = data;

  return <CurrentlyReadingCard book={book} userBook={ownerUserBook} />;
}
